/* Judge.me masque les prenoms en gardant la premiere et la derniere lettre (С***а).
   Sur une vitrine en alphabet latin, on les translittere ; le reste du texte n'est pas touche. */
(function () {
  var T = {'А':'A','Б':'B','В':'V','Г':'G','Ґ':'G','Д':'D','Е':'E','Ё':'Yo','Є':'Ye','Ж':'Zh','З':'Z','И':'I','І':'I','Ї':'Yi','Й':'Y','К':'K','Л':'L','М':'M','Н':'N','О':'O','П':'P','Р':'R','С':'S','Т':'T','У':'U','Ў':'U','Ф':'F','Х':'Kh','Ц':'Ts','Ч':'Ch','Ш':'Sh','Щ':'Shch','Ъ':'','Ы':'Y','Ь':'','Э':'E','Ю':'Yu','Я':'Ya'};
  var MASQUE = /([\u0400-\u04FF]?)(\*{2,})([\u0400-\u04FF]?)/g;
  function lettre(c) {
    var up = c.toUpperCase(), l = T[up];
    if (l === undefined) return c;
    return c === up ? l : l.toLowerCase();
  }
  function corrige(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, liste = [];
    while ((n = w.nextNode())) if (/[\u0400-\u04FF]\*{2,}|\*{2,}[\u0400-\u04FF]/.test(n.nodeValue)) liste.push(n);
    liste.forEach(function (t) {
      t.nodeValue = t.nodeValue.replace(MASQUE, function (m, a, s, b) { return (a ? lettre(a) : '') + s + (b ? lettre(b) : ''); });
    });
  }
  function go() {
    corrige(document.body);
    var file = null;
    new MutationObserver(function () {
      if (file) return;
      file = setTimeout(function () { file = null; corrige(document.body); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
